import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import DynamicBreadcrumb from "../../../components/DynamicBreadcrumb";
import BlogDetailBanner from "./BlogDetailBanner";
import BlogDetailCards from "./BlogDetailCards";
import BlogDetailContent from "./BlogDetailContent";
import BlogDetailFaq from "./BlogDetailFaq";
import { BaseUrl } from "../../../helper/BaseUrl";
import { useState, useEffect } from "react";


export default function BlogDetail({ initialData }) {
  const { slug } = useParams();
  const [data, setData] = useState(initialData?.detailpage || {});
  const navigate = useNavigate();
  useEffect(() => {
    const aifetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}api/blog/view/${slug}`, {
          method: 'GET',
        });
        const result = await response.json();
        if (!result.blog) {
          navigate("/404", { replace: true });
          return;
        }
        setData(result.blog);
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
    aifetcher();
  }, [slug, navigate]);

  const breadcrumbData = [
    { slug: "/", page: "Home" },
    { slug: "/blog", page: "Blog" },
    { slug: "", page: data?.title ? data.title.slice(0, 18) + "..." : "", },
  ];


  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <BlogDetailBanner data={data}/>
      <BlogDetailContent data={data}/>
      <BlogDetailFaq data={data}/>
      <BlogDetailCards initialData={initialData?.listpage}/>
    </>
  );
}
